// import { useState } from "react";


export default function StatusSolicitacoes({ status }) {
    // const [conteudo, setConteudo] = useState()
    // switch (tipoAnalise) {
    //     case status === 'Análise de Inspecção Física e Visual':
    //         return (

    //   );
    //   default:
    //       return null;
    //     }
    return (
        <>
            {status === 'Activo' &&
                <span style={{ borderRadius: 5, background: '#7ebf42', color: '#fff', padding: 5 }}>
                    AUTORIZADO
                </span>
            }

            {status === 'Inactivo' &&
                <span style={{ borderRadius: 5, background: 'red', color: '#fff', padding: 5 }}>
                    NÃO AUTORIZADO
                </span>
            }

            {status === 'Aprovado' &&
                <span style={{ borderRadius: 5, background: '#7ebf42', color: '#fff', padding: 5 }}>
                {status?.toUpperCase()}
                </span>
            }


            {status === 'Reprovado' &&
                <span style={{ borderRadius: 5, background: 'red', color: '#fff', padding: 5 }}>
                    {status?.toUpperCase()}
                </span>
            }

            {status === 'Suspenso' &&
                <span style={{ borderRadius: 5, background: 'red', color: '#fff', padding: 5 }}>
                    {status?.toUpperCase()}
                </span>
            }

            {status === 'Análise' &&
                <span style={{ borderRadius: 5, background: '#fce056', color: '#000', padding: 5 }}>
                    {status?.toUpperCase()}
                </span>
            }

            {status === 'Analisado' &&
                <span style={{ borderRadius: 5, background: '#fce056', color: '#000', padding: 5 }}>
                    {status?.toUpperCase()}
                </span>
            }

            {status === 'Analisado Chefe de Secção' &&
                <span style={{ borderRadius: 5, background: '#fce056', color: '#000', padding: 5 }}>
                    {status?.toUpperCase()}
                </span>
            }

            {status === 'Deferimento' &&
                <span style={{ borderRadius: 5, background: '#fce056', color: '#000', padding: 5 }}>
                    {/* {status?.toUpperCase()} */}
                    A aguardar aprovação
                </span>
            }


            {status === 'Não solicitado' &&
                <span style={{ borderRadius: 5, background: 'grey', color: '#fff', padding: 5 }}>
                    {/* {status?.toUpperCase()} */}
                    Não solicitado
                </span>
            }
        </>
    )
}